import React, { useEffect, useState } from 'react';
import { usePlanning } from "../planning21-context";
import PlantSchemaDrawing from "../../../components/PlantSchemaDrawing/PlantSchemaDrawing";
import { Gridder } from "../../../__generated__/types";
import { chain, keys } from 'lodash';
import { plantAmount } from "../../../utils/planting.util";
import styled from "styled-components";

interface PlantSchemaPageProps {

}

const gridders = {
  [Gridder.TWO_WHEELS]: 2,
  [Gridder.THREE_WHEELS]: 3,
  [Gridder.FOUR_WHEELS]: 4,
  [Gridder.SIX_WHEELS]: 6,
};

const GridderContainer = styled.div`
  display: grid;
  grid-template-columns: 200px 1fr;
  align-items: center;

  h1 {
text-align: center;
  }
`;

const GridderOptions = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;

  > div {
    width: 150px;
  }
`;

const PlantSchemaPage = (props: PlantSchemaPageProps) => {
  const {plantSchemas} = usePlanning();

  const [plantSchemaList, setPlantSchemaList] = useState<any>([]);

  useEffect(() => {
    const value = chain(plantSchemas)
      .map(plantSchema => {
        return {
          ...plantSchema,
          gridderRows: plantSchema.gridder ? gridders[plantSchema.gridder] : undefined,
          nrOfPlants: plantAmount(plantSchema, 1, 0.85, undefined),
          grid: `${plantSchema.distanceBetweenRows}cm x ${plantSchema.distanceInRow}cm`,
        }

      })
      .groupBy('gridderRows')
      .value();
    setPlantSchemaList(value);

  }, [plantSchemas]);


  return <div
    //value={orderBy(plantSchemaList, ['gridder'], ['asc'])}
  >
    {keys(plantSchemaList).map(gridder => <GridderContainer>
      <h1>{gridder}</h1>
      <GridderOptions className="gap-4">
        {plantSchemaList[gridder].map((x: any) => <div>
          <PlantSchemaDrawing plantSchema={x} plantWidth={10} plantLength={10}/>
        </div>)}
      </GridderOptions>
    </GridderContainer>)}
  </div>;
};

export default PlantSchemaPage;
